import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const ToolTip = styled(Box)(`
    position: fixed;
    z-index: 10;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    font-size: 13px;
    margin: 10px 0 0 10px;
    display:none;
`)
